import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, when} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {TldrawApp, useTldrawApp, WhiteboardShape} from '@modules/whiteboard/WhiteboardStore'
import {StoresInstance} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import {shapeIcons} from '~components/ToolsPanel/ShapesMenu'
import {EllipseShape, TDShape, TDShapeType} from '.'
import * as css from './ChooseShapePopoverContent.css'

/// region Store

export class ChooseShapePopoverContentStore {
  constructor(public props: Omit<MyProps, 'className'> & { tldraw: TldrawApp}) {
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  get tldraw() { return this.props.tldraw}
  get shape() { return this.props.shape}

  @observable foo = false

  @action onClickShape = (type: TDShapeType) => (e) => {
    const {shape, tldraw, tldraw: {shapeUtils, shapeComponentStores}} = this,
      originalShape = _.cloneDeep(shape),
      shapeUtil = shapeUtils[type]
    const newShape = _.merge(shapeUtil.getShape({}), shape, {type})

    _.assign(shape, newShape)
    if (type === 'ellipse' && originalShape['size']) {
      (shape as EllipseShape).radius = originalShape['size'].map(v => v / 2)
    }
    else if (type === 'rectangle' && originalShape['radius']) {
      shape['size'] = originalShape['radius'].map(r => r * 2)
    }

    if (type === 'sticky' || type === 'text') {
      tldraw.setEditingId(shape.id)
    }
  }
}

export const ChooseShapePopoverContentStoreContext = React.createContext<ChooseShapePopoverContentStore>(null)
export const useChooseShapePopoverContentStore = () => React.useContext(ChooseShapePopoverContentStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  shape: WhiteboardShape
}

export const ChooseShapePopoverContent = observer<MyProps>(function ChooseShapePopoverContent({className, ...props}) {
  const tldraw = useTldrawApp(),
    obsProps = useAsObservableSource({...props, tldraw}),
    store = useLocalStore(() => new ChooseShapePopoverContentStore(obsProps)),
    {onClickShape} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <ChooseShapePopoverContentStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <PrimaryIconButton icon={shapeIcons.rectangle} onClick={onClickShape('rectangle')} />
        <PrimaryIconButton icon={shapeIcons.ellipse} onClick={onClickShape('ellipse')}/>
        <PrimaryIconButton icon={shapeIcons.text} onClick={onClickShape('text')}/>
        <PrimaryIconButton icon={shapeIcons.sticky} onClick={onClickShape('sticky')}/>
        <PrimaryIconButton icon={shapeIcons.frame} onClick={onClickShape('frame')}/>
      </div>
    </ChooseShapePopoverContentStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/whiteboard/ChooseShapePopoverContent.tsx